module.exports = __webpack_public_path__ + "static/media/CartHero1.aa4a2b4c.svg";